import styled from '@emotion/styled'

import {Body, Content, PopUp} from '@vio/atlas/PopUp'
import {linariaMq} from '@vio/atlas/src/utils/breakpoints'
import {cssTheme} from '@vio/atlas-tokens'

export const DESKTOP_MAX_WIDTH = 1200
export const DESKTOP_NO_IMAGE_WIDTH = 480
const DESKTOP_MAX_HEIGHT = 919

export const StyledPopUp = styled(PopUp)`
  & > div {
    padding: ${cssTheme.layout.spacing.s800};
  }

  ${Content} {
    width: calc(100vw - ${cssTheme.layout.spacing.s800});
    height: calc(100dvh - ${cssTheme.layout.spacing.s800});

    ${linariaMq.desktopLg} {
      max-height: ${DESKTOP_MAX_HEIGHT}px;
    }
  }
  ${Body} {
    height: 100%;
  }
`

export const MobileImageWrapper = styled.div`
  aspect-ratio: 16 / 9;
`

/** Keeps the footer pinned at the bottom without fixed positioning. */
export const ContentColumn = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
`

export const ScrollRegion = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  overscroll-behavior-y: contain;
`

export const DesktopContentWrapper = styled(ContentColumn)`
  width: 480px;
`

export const DesktopNoImageContentWrapper = styled(ContentColumn)`
  flex: 1;
`
